import { Route, Routes as ReactRouterRoutes } from 'react-router-dom';

import { CalendarCallbackPage } from '../../pages/CalendarCallback/CalendarCallbackPage';
import { DossierPage } from '../../pages/Dossier/Dossier';
import { FiltersPanelLayout } from '../../pages/Filters/FiltersPanelLayout';
import { HomepageRoute } from '../../pages/Homepage/HomepageRoute';
import { MessageTemplateRoutes } from '../../pages/MessageTemplate/Route';
import { PipelineRoutes } from '../../pages/Pipeline/Route';
import { TodoRoutes } from '../../pages/Todo/Route';
/* AB ab_flex_offer — sunsets 2026-10-31, delete this import + its usage below */
import { AB_FlexOfferSuiviRoute } from '../../pages/AB_FlexOfferSuivi';
import { AB_FLEX_OFFER_SUIVI_PATH } from '../../pages/AB_FlexOfferSuivi/AB_useFlexOfferEligible';

import { NotFoundRedirect } from './NotFoundRedirect';

export const DEFAULT_VIEW_ROUTE = '/homepage';

export const Routes = (): JSX.Element => (
    <ReactRouterRoutes>
        <Route element={<FiltersPanelLayout />}>
            <Route path="/homepage/*" element={<HomepageRoute />} />
            <Route path="/process/*" element={<PipelineRoutes />} />
            <Route path="/todo/*" element={<TodoRoutes />} />
        </Route>
        <Route path="/templates/*" element={<MessageTemplateRoutes />} />
        <Route path="/calendar/callback" element={<CalendarCallbackPage />} />
        {/* AB ab_flex_offer — sunsets 2026-10-31 */}
        <Route path={AB_FLEX_OFFER_SUIVI_PATH} element={<AB_FlexOfferSuiviRoute />} />
        <Route path="/dossier/:dossierId/*" element={<DossierPage />} />
        <Route path="*" element={<NotFoundRedirect to={DEFAULT_VIEW_ROUTE} />} />
    </ReactRouterRoutes>
);
